import * as Sentry from '@sentry/react'

interface LogErrorOptions {
  context?: string
  metaData?: Record<string, unknown>
}

export function logError(error: unknown, opts: LogErrorOptions = {}): void {
  const options = {
    context: 'composer',
    ...opts,
  }

  Sentry.withScope((scope) => {
    scope.setTag('source', 'logError')
    scope.setTag('context', options.context)

    if (options.metaData) {
      scope.setExtras(options.metaData)
    }

    Sentry.captureException(error)
  })

  // todo: consider debug library
  // eslint-disable-next-line no-console
  console.error(error, options)
}
